import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import browserFileIcon from '../node_modules/@ckeditor/ckeditor5-ckfinder/theme/icons/browse-files.svg';

export class CustomImageChoosingButton extends Plugin {
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('customImageChoosingButton', (locale) => {
      const buttonView = new ButtonView(locale);

      buttonView.set({
        label: editor.i18n.t('画像やファイルの挿入'),
        icon: browserFileIcon,
        tooltip: true,
      });

      buttonView.on('execute', (e) => this.onExecute(e));

      // // isReadOnlyが変更されたら、ボタンのisEnabledを変更する
      // buttonView.bind('isEnabled').to(editor, 'isReadOnly', (isReadOnly) => {
      //   if (isReadOnly === true) {
      //     return false; // 読み取り専用の場合は、必ずボタンを無効化
      //   }
      //   return _.get(editor, 'config._config.customValues.isOwnProduction', false); // ckfinderが利用可能な場合のみボタンを有効にする
      // });

      return buttonView;
    });
  }

  onExecute(e) {
    window.ckfinderMode = 'insert'; // ckfinderのモードをセット
    const ckfinerCommand = this.editor.commands.get('ckfinder');
    if (ckfinerCommand && typeof ckfinerCommand.execute === 'function') {
      ckfinerCommand.execute(); // ckfinderを開く
    }
  }
}
